// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"ButtonLoader_loader_wrapper__M047F","loader":"ButtonLoader_loader__ENfRU","rotation":"ButtonLoader_rotation__l5sXv"};